/**
 * Business-error model for the Add Licence form.
 *
 * Discriminated union: the generic `network` / `api` transport failures (from
 * the app-wide `@/utils/infra-error` classifier, shared with the Licences index)
 * plus the form-specific `validation` variant (field-level messages produced by
 * `validateDraft`). No `cancelled` variant; a single create POST has no
 * abortable phase (unlike the multi-phase list wizards). Local to the feature so
 * it never couples to another domain.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

export type AddLicenceError =
  | InfraFailure
  | { kind: 'validation'; fields: Record<string, string> };

/**
 * Map an infrastructure error into a domain `AddLicenceError`. Only ever yields
 * a `network` / `api` failure; `validation` errors are produced directly by the
 * feature's `validateDraft`.
 */
export function toAddLicenceError(e: unknown): AddLicenceError {
  return classifyInfraError(e, 'Failed to create licence.');
}
